// class name helper
export default function cnh(
  ...classes: (string | undefined)[]
) {
  return classes.join(' ');
}
